module.exports = __webpack_public_path__ + "static/img/3-info-b7.03d89f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3-info-b7.jpg
// module id = XYsi
// module chunks = 0